import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const PopularFilters = () => {
  const [showAll, setShowAll] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="list-trip">
      <h4>{t("popularFilters")}</h4>
      <ul className="list-unstyled p-0 m-0">
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck1" />
              <label className="form-check-label" htmlFor="gridCheck1">
                {t("hotels")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">120</div>
          </div>
        </li>
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck2" />
              <label className="form-check-label" htmlFor="gridCheck2">
                {t("breakfastIncluded")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">21</div>
          </div>
        </li>
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck3" />
              <label className="form-check-label" htmlFor="gridCheck3">
                {t("parking")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">62</div>
          </div>
        </li>
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck4" />
              <label className="form-check-label" htmlFor="gridCheck4">
                {t("veryGood")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">33</div>
          </div>
        </li>
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck5" />
              <label className="form-check-label" htmlFor="gridCheck5">
                {t("basedOnGuestReviews")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">25</div>
          </div>
        </li>

        {showAll && (
          <>
            <li>
              <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                <div className="radioBox">
                  <input className="form-check-input" type="checkbox" id="gridCheck6" />
                  <label className="form-check-label" htmlFor="gridCheck6">
                    {t("privateBathroom")}
                  </label>
                </div>
                <div className="d-flex align-items-center text-right-box">65</div>
              </div>
            </li>
            <li>
              <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                <div className="radioBox">
                  <input className="form-check-input" type="checkbox" id="gridCheck7" />
                  <label className="form-check-label" htmlFor="gridCheck7">
                    {t("swimmingPool")}
                  </label>
                </div>
                <div className="d-flex align-items-center text-right-box">156</div>
              </div>
            </li>
            <li>
              <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                <div className="radioBox">
                  <input className="form-check-input" type="checkbox" id="gridCheck8" />
                  <label className="form-check-label" htmlFor="gridCheck8">
                    {t("resorts")}
                  </label>
                </div>
                <div className="d-flex align-items-center text-right-box">20</div>
              </div>
            </li>
            <li>
              <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                <div className="radioBox">
                  <input className="form-check-input" type="checkbox" id="gridCheck9" />
                  <label className="form-check-label" htmlFor="gridCheck9">
                    {t("airConditioning")}
                  </label>
                </div>
                <div className="d-flex align-items-center text-right-box">50</div>
              </div>
            </li>
          </>
        )}
      </ul>

      <div className="drop-box-price">
        <button
          type="button"
          className="btn-text bg-transparent border-0 d-flex align-items-center gap-2"
          onClick={() => setShowAll(!showAll)}
        >
          <span>{showAll ? t("showLess") : t("showAll")}</span>
          <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L7.5 7L14 1" stroke="#33A7F6" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default PopularFilters;
